// MANISH CUSTOM CODE FOR CATEGORY CARDS - START
// Prev/Next nav buttons that scroll exactly one card at a time, replacing
// the visible scrollbar (which is hidden via CSS). Buttons auto-disable at
// the start/end of the row and stay in sync with touch-swipe scrolling too.

class MmCategoryCardsNav {
  constructor(wrap) {
    this.wrap = wrap;
    this.row = wrap.querySelector('[data-mm-cards-row]');
    this.prevBtn = wrap.querySelector('.mm-category-cards__nav--prev');
    this.nextBtn = wrap.querySelector('.mm-category-cards__nav--next');
    if (!this.row || !this.prevBtn || !this.nextBtn) return;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
    this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
    this.row.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    this.updateButtons();
  }

  onScroll() {
    window.clearTimeout(this._scrollTimeout);
    this._scrollTimeout = window.setTimeout(() => this.updateButtons(), 80);
  }

  onResize() {
    window.clearTimeout(this._resizeTimeout);
    this._resizeTimeout = window.setTimeout(() => this.updateButtons(), 120);
  }

  getStep() {
    const firstItem = this.row.querySelector('.mm-category-cards__item');
    if (!firstItem) return this.row.clientWidth;
    const style = window.getComputedStyle(this.row);
    const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    return firstItem.getBoundingClientRect().width + gap;
  }

  scrollByCard(direction) {
    this.row.scrollBy({ left: this.getStep() * direction, behavior: 'smooth' });
  }

  updateButtons() {
    const maxScroll = this.row.scrollWidth - this.row.clientWidth;
    const noScrollNeeded = maxScroll <= 2;
    const atStart = this.row.scrollLeft <= 2;
    const atEnd = this.row.scrollLeft >= maxScroll - 2;

    this.prevBtn.disabled = noScrollNeeded || atStart;
    this.nextBtn.disabled = noScrollNeeded || atEnd;
    this.wrap.classList.toggle('mm-category-cards--no-scroll', noScrollNeeded);
  }
}

function mmInitCategoryCardsNav() {
  document.querySelectorAll('.mm-category-cards__nav-wrap').forEach((wrap) => {
    if (wrap.dataset.mmNavInit) return;
    wrap.dataset.mmNavInit = 'true';
    new MmCategoryCardsNav(wrap);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mmInitCategoryCardsNav);
} else {
  mmInitCategoryCardsNav();
}

// Re-init when the section is added/reloaded live in the theme editor.
document.addEventListener('shopify:section:load', mmInitCategoryCardsNav);

// MANISH CUSTOM CODE FOR CATEGORY CARDS - END
